import BusinessDevelopmentDashboardTemplate from "Components/templates/business-development/dashboard";

const BusinessDevelopmentDashboard = () => {
    document.title = "Business Development Dashboard | IbexIQ";

    return <BusinessDevelopmentDashboardTemplate /> 
}

export default BusinessDevelopmentDashboard;